import React, { useEffect } from 'react';

const LanguageSelector = () => {
  useEffect(() => {
    // Load Google Translate script
    const script = document.createElement('script');
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    document.body.appendChild(script);

    // Define the callback function
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        { 
          pageLanguage: 'en', 
          layout: window.google.translate.TranslateElement.InlineLayout.HORIZONTAL 
        }, 
        'google_translate_element'
      );
    };

    return () => {
      // Cleanup
      document.body.removeChild(script);
      delete window.googleTranslateElementInit;
    };
  }, []);

  return <div id="google_translate_element" className="w-full flex justify-center"></div>;
};

export default LanguageSelector;
